(function () {
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function getVariantInput() {
    return (
      document.querySelector('form[action^="/cart/add"] [name="id"]') ||
      document.querySelector("product-form [name='id']") ||
      document.querySelector("[name='id']")
    );
  }

  let lastValue = null;

  function dispatchVariantEvents(el) {
    if (!el) return;
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  onReady(function () {
    const input = getVariantInput();
    if (!input) return;

    lastValue = input.value;

    // Watch for value change only
    const observer = new MutationObserver(function () {
      const current = getVariantInput();
      if (!current) return;

      if (current.value !== lastValue) {
        lastValue = current.value;

        // Delay slightly so theme finishes updating everything
        setTimeout(function () {
          dispatchVariantEvents(current);
        }, 50);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback interval (in case no DOM mutation fires)
    setInterval(function () {
      const current = getVariantInput();
      if (!current) return;

      if (current.value !== lastValue) {
        lastValue = current.value;
        setTimeout(function () {
          dispatchVariantEvents(current);
        }, 50);
      }
    }, 300);
  });
})();
